import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/boerne")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Boerne, TX | Texas Made Shade",
      description: "Custom welded awnings, patio & pergola covers, sail shades and outdoor curtains for Boerne & Kendall County. Built in Seguin, installed in the Hill Country.",
      keywords: "pergola covers Boerne, pergola covers Texas, custom pergola covers Boerne, aluminum pergola covers Boerne",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Boerne, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Boerne and Kendall County.",
    }),
    scripts: cityHeadScripts("Boerne", "Kendall County"),
  }),
  component: () => <CityHomePage city="Boerne" region="Kendall County" />,
});
